// Components==============
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import React from 'react';
import './Spark.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
// =========================

export default function Spark({
  spark,
  onClick,
  grey,
  end,
  handleDelete,
}: {
  spark: SparkEntity;
  onClick?: () => void;
  grey?: boolean;
  end?: boolean;
  handleDelete?: (sparkItem: SparkEntity) => void;
}) {
  const skill = useRedux((state) => state.skill?.entities.byId[spark.skill_id]);

  const handleClickDelete = () => {
    if (handleDelete) {
      handleDelete(spark);
    }
  };

  return (
    <motion.div
      styleName={`wrapper ${grey ? 'grey' : end ? 'end' : skill?.type}`}
      whileHover={onClick ? { scale: 1.02 } : {}}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      initial={{ scale: 1, opacity: 0 }}
      whileTap={onClick ? { scale: 0.98 } : {}}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'initial' }}
    >
      <p>{spark.name}</p>
      {!!handleDelete && (
        <div styleName="delete " onClick={handleClickDelete}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      )}
    </motion.div>
  );
}
